import React from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router'

import { UserInfoResponse, GeneralResponse } from 'protos'
import { getUserId } from 'store/modules/session/selectors'
import { AppState } from 'store/types'

import UserLayer from './UserLayer'

interface Props {
  getUserInfo: (userId: string) => Promise<UserInfoResponse>
  addFriend: (userId: string, targetId: string) => Promise<GeneralResponse>
  removeFriend: (userId: string, targetId: string) => Promise<GeneralResponse>
  onChallenge: (userId: string) => void
  children: React.ReactNode
}

const mapStateToProps = ({ session }: AppState) => ({
  ownUserId: getUserId(session),
})

type InjectedProps = Props & RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

const UserLayerProvider = ({
  getUserInfo,
  addFriend,
  removeFriend,
  onChallenge,
  ownUserId,
  location,
  history,
  children,
}: InjectedProps) => {
  const userId = new URLSearchParams(location.search).get('userLayer') || undefined

  return (
    <>
      {children}
      {userId && (
        <UserLayer
          isSelf={userId === ownUserId}
          onClose={() => { history.goBack() }}
          getUserInfo={() => getUserInfo(userId)}
          addFriend={() => addFriend('me', userId)}
          removeFriend={() => removeFriend('me', userId)}
          onChallenge={() => onChallenge(userId)}
        />
      )}
    </>
  )
}

export default connect(mapStateToProps)(withRouter(UserLayerProvider))
try {
    // @ts-ignore
    UserLayerProvider.displayName = "UserLayerProvider";
    // @ts-ignore
    UserLayerProvider.__docgenInfo = { "description": "", "displayName": "UserLayerProvider", "props": { "ref": { "defaultValue": null, "description": "", "name": "ref", "required": false, "type": { "name": "LegacyRef<Component<Pick<InjectedProps, \"children\" | \"ownUserId\" | \"getUserInfo\" | \"addFriend\" | \"removeFriend\" | \"onChallenge\">, any, any>>" } }, "getUserInfo": { "defaultValue": null, "description": "", "name": "getUserInfo", "required": true, "type": { "name": "(userId: string) => Promise<any>" } }, "addFriend": { "defaultValue": null, "description": "", "name": "addFriend", "required": true, "type": { "name": "(userId: string, targetId: string) => Promise<any>" } }, "removeFriend": { "defaultValue": null, "description": "", "name": "removeFriend", "required": true, "type": { "name": "(userId: string, targetId: string) => Promise<any>" } }, "onChallenge": { "defaultValue": null, "description": "", "name": "onChallenge", "required": true, "type": { "name": "(userId: string) => void" } }, "key": { "defaultValue": null, "description": "", "name": "key", "required": false, "type": { "name": "string | number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/UserLayer/UserLayerProvider.tsx#UserLayerProvider"] = { docgenInfo: UserLayerProvider.__docgenInfo, name: "UserLayerProvider", path: "src/components/UserLayer/UserLayerProvider.tsx#UserLayerProvider" };
}
catch (__react_docgen_typescript_loader_error) { }